module.exports = new __parcel__URL__("6904.26c143d4.jpg").toString();